import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { PageCard } from '../layout/page/PageCard';
import {
  listSalesProductLinkedApplications,
  SalesProductLinkedApplication,
} from '../../services/salesProductWorkspaceApi';
import { getRequestErrorMessage } from '../../utils/getRequestErrorMessage';

type ProductLinkedApplicationsPanelProps = {
  productId: string;
};

export function ProductLinkedApplicationsPanel({ productId }: ProductLinkedApplicationsPanelProps) {
  const [items, setItems] = useState<SalesProductLinkedApplication[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void (async () => {
      setLoading(true);
      try {
        setItems(await listSalesProductLinkedApplications(productId));
      } catch (error) {
        toast.error(getRequestErrorMessage(error, 'Falha ao carregar as aplicações do produto.'));
      } finally {
        setLoading(false);
      }
    })();
  }, [productId]);

  return (
    <PageCard
      title="Aplicações"
      subtitle="Dependências técnicas deste produto. A composição é mantida em Tecnologia → Sistemas."
    >
      {loading ? (
        <p className="text-sm text-secondary-500">Carregando...</p>
      ) : items.length === 0 ? (
        <p className="text-sm text-secondary-500">
          Nenhuma aplicação vinculada. Defina a composição em Tecnologia → Sistemas.
        </p>
      ) : (
        <ul className="divide-y divide-secondary-100 rounded-lg border border-secondary-200">
          {items.map((item) => (
            <li key={item.applicationId} className="px-4 py-3 text-sm text-secondary-900">
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </PageCard>
  );
}
